import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const salesReturnsPdf = () => {
    const { formatDate } = useDate();
    const store = useStore();
    const { commaFormat } = figureFormatter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, salesReturnList, total, date) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 100, 30, 80 ],
            pageOrientation: 'portrait',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(salesReturnList, total, date),

            styles : {
                header: {
                    fontSize: 16
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 9,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'CREDIT NOTE LIST'
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (salesReturnList, total, date) => {
        return [
            {
                text: 'CREDIT NOTE LIST',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                decoration: 'underline'
            },

            {
                stack: [
                    {
                        text: `Date: ${date.startDate} - ${date.endDate}`
                    }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['13%', '15%', '20%', '27%', '12%', '13%'],
                    body: getTableBody(salesReturnList, total)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getTableBody = (salesReturnList, total) => {
        const header = getTableHead();
        const row = getTableRow(salesReturnList, total);
        return [
            header,
            ...row
        ]
    }

    const getTableRow = (salesReturnList, total) => {
        const data = [];

        salesReturnList.map((item) => {
            const row = [
                { text: item.date },
                { text: item.bill_number },
                { text: `${item.sale_bill_number ? item.sale_bill_number : ''} ${item.sale_bill_date ? item.sale_bill_date : ''}` },
                { text: item.party_name },
                { text: commaFormat(item.bill_amount), alignment: 'right' },
                { text: commaFormat(item.paid_amount), alignment: 'right' }
            ];
            data.push(row);
        })

        const totalRow = [
            { text: `Total`, colSpan: 4, alignment: 'right' },
            {}, {}, {},
            { text: total.total_bill_amount, alignment: 'right' },
            { text: total.total_paid_amount, alignment: 'right' }
        ];

        data.push(totalRow);
        return data
    }

    const getTableHead = () => {
        return [
            { text: 'DATE' },
            { text: 'CREDIT NOTE NUMBER' },
            { text: 'BILL NUMBER AND DATE' },
            { text: 'PARTY NAME' },
            { text: 'RETURN AMOUNT', alignment: 'right' },
            { text: 'REFUND AMOUNT', alignment: 'right' },
        ]
    }

    const getHeader = (company) => {
        return {
            margin: [ 30, 25, 30, 10 ],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },

                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        }
    }

    const getFooter = (userName) => {
        return {
            margin: [ 25, 0 ],
            columns: [
                {
                    columns: [
                        {
                            width: '90%',
                            alignment: 'left',
                            text: 'N.B: This is a system generated documents and requires no manual signature.',
                            margin: [5, 53, 0, 0],
                            fontSize: 8
                        }
                    ]
                },

                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        {
                            text: 'Printed by',
                            bold: true
                        },
                        {
                            text: userName
                        },
                        {
                            text: formatDate(new Date())
                        }
                    ]
                }
            ]
        }
    }

    return {
        exportToPDF
    }
}

export default salesReturnsPdf;
